import { Model } from "@tailflow/laravel-orion/lib/model";

export class TermsAndCondition extends Model<{
  name: string;
  description: string;
  created_at: string;
  updated_at: string;
}> {
  public $resource(): string {
    return "terms-and-conditions";
  }
}
